import { formatDateToString } from '~/helpers'
import i18n from '~/i18n'

import RequestContent from '../components/RequestContent'
import RequestTitle from '../components/RequestTitle'
import {
  collapseDestinationUrlDetails,
  omitRedundantDestinationCreates
} from './collapseDestinationUrlAudit'

type GroupedLogsByDate = {
  data: AuditLogItem[]
  debug: boolean
}

const formatGroupByDate = ({ data, debug }: GroupedLogsByDate) => {
  const flattenChangesReduce = (
    acc: FlattenChanges,
    change: AuditLogItemChange
  ) => [
    ...acc,
    ...collapseDestinationUrlDetails(change.details)
      .map(detail => ({ ...change, ...detail }))
      .filter(filteredKeys => !!filteredKeys)
  ]

  const formatChangesMap = (change: FlattenChange) => {
    const hideContent =
      change.field_name === 'payload_create' &&
      (change.entity === 'campaign' ||
        change.entity === 'campaign_destination_url') &&
      !debug

    return {
      id: `${change.action}${change.id}`,
      template: change.entity === 'ad' ? 'primary' : 'success',
      time: formatDateToString(change.created_at, 'HH:mm'),
      title: <RequestTitle data={change} />,
      content: hideContent ? null : (
        <RequestContent data={change} isDebug={!!debug} />
      )
    } as ItemVerticalTimeline
  }

  const formattedDataByDate: FormattedDataByDate = data.reduce((acc, item) => {
    const date = formatDateToString(
      item.changes[0].created_at,
      i18n.t('c:patterns.dateWithWeekday')
    )

    const flattenChanges = omitRedundantDestinationCreates(
      item.changes.reduce<FlattenChanges>(
        (acc, change) => flattenChangesReduce(acc, change),
        []
      )
    )
    const formattedChanges = flattenChanges.map(formatChangesMap)
    const currentDate = [...(acc[date] || []), ...formattedChanges]

    return {
      ...acc,
      [date]: currentDate
    }
  }, {} as FormattedDataByDate)

  return Object.entries(formattedDataByDate).map(([title, data]) => ({
    title,
    data,
    id: title
  }))
}

export default formatGroupByDate
